import {
  ADDON_UNIT_SIZE,
  STANDARD_ALLOWANCE,
} from './billingFormatters';

export const PLAN_CATALOG = {
  FREE: {
    planId: 'FREE',
    description:
      'Try Workflow86 with your own provider API key and a one-time credit grant after validation.',
    features: [
      '500 credits once after you connect a provider API key',
      'Bring your own API key required for AI',
      'Up to 5 team members',
      'Up to 3 workflows',
      '100 MB file storage',
      'No monthly credit refill',
    ],
  },
  STANDARD: {
    planId: 'STANDARD',
    description:
      'Platform-managed AI, monthly credits, and optional bundles for teams that want predictable billing.',
    features: [
      `${STANDARD_ALLOWANCE.toLocaleString()} credits per month`,
      'Platform-managed AI keys included',
      'Optional BYOK — 85% credit discount',
      'Up to 50 team members',
      'Up to 100 workflows',
      '10 GB file storage',
      `Add credit bundles (+${ADDON_UNIT_SIZE.toLocaleString()} credits each)`,
      'Optional on-demand usage when credits run out',
    ],
  },
  ENTERPRISE: {
    planId: 'ENTERPRISE',
    description:
      'Custom limits, SSO, audit controls, and dedicated support for large organizations.',
    features: [
      'Custom credit allowance and limits',
      'SSO and audit log',
      'Custom branding',
      'Priority and dedicated support',
      'Admin-configured on-demand usage',
    ],
  },
};

export function getPlanCatalog(planId) {
  return PLAN_CATALOG[planId] || PLAN_CATALOG.STANDARD;
}

/** Free-plan org page — row data for Free vs Standard comparison table. */
export function getFreeStandardComparisonRows() {
  return [
    {
      label: 'Credits',
      free: '500 once',
      standard: `${STANDARD_ALLOWANCE.toLocaleString()} / month`,
    },
    {
      label: 'AI keys',
      free: 'Your key required',
      standard: 'Platform-managed',
      standardDetail: 'Optional BYOK — 85% credit discount',
    },
    {
      label: 'Team members',
      free: '5',
      standard: '50',
    },
    {
      label: 'Workflows',
      free: '3',
      standard: '100',
    },
    {
      label: 'File storage',
      free: '100 MB',
      standard: '10 GB',
    },
    {
      label: 'Credit bundles',
      free: 'Not available',
      standard: `+${ADDON_UNIT_SIZE.toLocaleString()} / bundle`,
    },
    {
      label: 'On-demand usage',
      free: 'Not available',
      standard: 'Optional',
    },
  ];
}
